import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1d785f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { class: "text-center -mt-5 mb-x4" }
const _hoisted_3 = { class: "px-50" }
const _hoisted_4 = {
  key: 0,
  class: "px-30"
}
const _hoisted_5 = { class: "o-scrollbar-y px-x3 pb-10 max-height min-h-120" }
const _hoisted_6 = {
  key: 0,
  class: "text-center min-h-100 flex items-center px-30"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex-1 min-w-0 pl-20 xl:pl-30" }
const _hoisted_11 = { class: "truncate mr-15" }
const _hoisted_12 = { class: "o-text-caption" }

import WishlistCreate from '@/shared/product/wishlist/ui/WishlistCreate.vue';
import useWishlist, { ensureOverlayAnimationBeforeClosingTiming } from '@/shared/product/wishlist/useWishlist';
import { getProductWishlistMessageId, useWishlistApi } from '@/shared/product/wishlist/useWishlistApi';
import WishlistThumbView from '@/shared/product/wishlist/ui/WishlistThumbView.vue';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import AnimateValue from '@/core/ui-components/AnimateValue.vue';
import utilities from '@/shared/utilities.service';
import { computed } from 'vue';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import dictionaryService from '@/core/dictionary/dictionary.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'WishlistLists',
  setup(__props) {

const labels = useGlobalLabels(GlobalLabels.wishlist);
const { activeName, activeSku, lists, clearActive, setLists } = useWishlist();
const { get, add } = useWishlistApi();

const init = async() => {
    const result = await get();
    setLists(result);
};
init();

const addAndClose = async(id, sku) => {
    await add(id, sku);
    await init();
    await utilities.delay(ensureOverlayAnimationBeforeClosingTiming);
    clearActive();
};

const hasNoLists = computed<boolean>(() => lists.value.length === 0);

const ensureListEntryFocus = (el: HTMLElement): void => {
    el.scrollIntoView();
};

const getListTitle = (name) => dictionaryService.formatNamed(labels.addToSelectedList, { product: activeName?.value ?? '', list: name });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(labels).selectListTitle), 1),
      (_unref(activeName))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(activeName)), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_Transition, {
        name: "o-anim-fade-200",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_unref(hasNoLists))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("h4", null, _toDisplayString(_unref(labels).noListsCreatedText), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_TransitionGroup, {
                  name: "o-anim-fade-200",
                  onEnter: ensureListEntryFocus
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lists), (list) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: list.id,
                        class: "list",
                        onClick: ($event: any) => (addAndClose(list.id, _unref(activeSku)))
                      }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "sr-only",
                          onClick: ($event: any) => (addAndClose(list.id, _unref(activeSku)))
                        }, _toDisplayString(getListTitle(list.name)), 9, _hoisted_9),
                        _createVNode(WishlistThumbView, {
                          items: list.skus,
                          class: "w-130 flex-none"
                        }, null, 8, ["items"]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("h4", _hoisted_11, _toDisplayString(list.name), 1),
                          _createElementVNode("p", null, [
                            _createVNode(AnimateValue, {
                              value: _ctx.$dictionary.formatNamed(_unref(labels).listItemCount, { count: list.skus.length })
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).listCreatedDate, { date: list.formattedDate })), 1),
                          _createVNode(WebApiMessage, {
                            id: _unref(getProductWishlistMessageId)(list.id),
                            "clear-timing": 3000,
                            class: "message"
                          }, null, 8, ["id"])
                        ])
                      ], 8, _hoisted_8))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
        ]),
        _: 1
      })
    ]),
    _createVNode(WishlistCreate, { class: "mt-x3 min-h-36" })
  ]))
}
}

})